import { useHistory } from "react-router-dom"
import { useI18n } from "providers/I18n"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { StyledFilterInput } from "./StyledFilterInput"

type Props = {
  years?: string[]
}

export function FilterYear(props: Props) {
  const { t } = useI18n()
  const history = useHistory()
  const { years } = props
  const { pathname, search, yearParam } = useRevenueParams()

  const options =
    years?.map((year: string) => ({
      label: t(year),
      value: year,
    })) || []

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedUrl = new URLSearchParams(search)
    updatedUrl.set("year", e.target.value)

    history.push({ pathname, search: updatedUrl.toString() })
  }

  return (
    <StyledFilterInput
      name="year"
      label={t("revenue.filter.year")}
      value={yearParam}
      options={options}
      onChange={onChange}
    />
  )
}
